import React, { useState, useEffect, useRef } from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import { TextareaAutosize,Paper,Tooltip} from '@material-ui/core'
import { Link } from 'react-router-dom';
import { DatePickerInput } from 'rc-datepicker'

  const todate = new Date()
 const NextFollowupDate = todate.getFullYear()-1 + '/04/01';

const ProductMaster = (props) => { 
  const classes = useStyles(); 
  const [Mode, setMode] = useState("");
  const [POCID, setPOCID] = useState({ id:props.POCID });
  const [POCNo, setPOCNo] = useState("");
  const [POCDate, setPOCDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
  const [ProductCode, setProductCode] = useState("");
  const [ProductName, setProductName] = useState("");
  const [ProductType, setProductType] = useState("");
  const [CurrentSolution, setCurrentSolution] = useState("");
  const [NoOfUsers, setNoOfUsers] = useState("");
  const [AD_LDAPSync, setAD_LDAPSync] = useState("");
  const [POCType, setPOCType] = useState("");
  const [OnPrimCloud, setOnPrimCloud] = useState("");
  const [NoOfUsersInPOC, setNoOfUsersInPOC] = useState("");
  const [RequestedByID, setRequestedByID] = useState(sessionStorage.UserName);
  const [RequestedOn, setRequestedOn] = useState(Moment(new Date()).format("YYYY-MM-DD"));
  const [ProductTypeID, setProductTypeID]=useState({ id: props.ProductTypeID, ProductType: ProductType });
  const [ProductID, setProductID]=useState({ id: props.ProductID, Product: ProductName });
  const [ProductCodeID, setProductCodeID]=useState({ id: props.ProductID, Product: ProductCode });
  const [RenewDate, setRenewDate]=useState("");
  const [POCStartDate, setPOCStartDate]=useState("");
  const [POCEndDate, setPOCEndDate]=useState("");
  const [isRequestPOCOpen, setRequestPOCOpen] = useState(false);
  const [Description, setDescription] = useState("");
  const [isOpen, setOpen] = useState(false);
  const [defaultToDate, setdefaultToDate] = useState(todate);
  const [ToDate, setToDate] = useState(todate.toISOString());
  const [response, fetchData] = UseFetchData();
  const [responseFollowup, fetchFollowupData] = UseFetchData();
  const [isChecked, setIsChecked] = useState(false);
  const [responseGetData, fetchDataGetData] = UseFetchData();
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const { value, onChange, ...rest } = props;
  const [cursor, setCursor] = useState(null);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [rows1, setRows1] = useState([]);
  const [columns1, setColumns1] = useState([]);
  const [response1, fetchData1] = UseFetchData();
  const [rows2, setRows2] = useState([]);
  const [response2, fetchData2] = UseFetchData();
  const [columns2, setColumns2] = useState([]);
  const [Count, setCount] = useState();
  const [responseContDtls, fetchContDtls] = UseFetchData();
  const [responseContByIDDtls, fetchContByIDDtls] = UseFetchData();
  const ref = useRef(null);

//   const validationSchema = Yup.object({
//     Salutation: Yup.string().required("Required!"),
//     LeadStatus: Yup.string().required("Required!"),
//     ContactName: Yup.string().required("Required!"),
//     Designation: Yup.string().required("Required!"),
//     Department: Yup.string().required("Required!"),
//     // NoOfEmp: Yup.number().required("Required!"),
//     CompanyName: Yup.string().required("Required!"),
//     IndustryID: Yup.string().required("Required!"),
//     LeadSourceID: Yup.string().required("Required!"),
//     Rating: Yup.string().required("Required!"),
//     Mobile: Yup.string().required("Required!"),
//     Phone: Yup.string().required("Required!"),
//     Email: Yup.string().required("Required!"),
//     City: Yup.string().required("Required!"),
//     CountryID: Yup.string().required("Required!"),
//     StateID: Yup.string().required("Required!"),
//     // CurrencyID: Yup.string().required("Required!")
//   });


useEffect(() => {
  const gridCols = [
      {
          field: "id",
          headerName: ".",
          renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
          //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ), 
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 70,
      },
      {
          field: "ServiceEngineerName",
          headerName: "Service Engineer Name",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 170,
      },
      {
          field: "MobileNo",
          headerName: "Mobile No",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
      },
      {
          field: "AppUserType",
          headerName: "App User Type",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
      },
      {
          field: "AppUserLoginName",
          headerName: "App User Login Name",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
      },
      {
          field: "AppUserPassword",
          headerName: "App User Password",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 210,
      },
      {
        field: "IsActive",
        headerName: "Is Active",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
    },

  ];
  setColumns(gridCols);
  setRows(response);
  setCount(response.length);
}, [response]
);


useEffect(() => {
  const gridCols1 = [
      {
          field: "id",
          headerName: ".",
          renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
          //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ), 
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 70,
      },
      {
          field: "ServiceCentre",
          headerName: "Service Centre",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 170,
      },
      {
          field: "ServiceEngineerName",
          headerName: "ServiceEngineerName",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
      },
      {
          field: "Zone",
          headerName: "Zone",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
      },
      {
          field: "TotalCallToday",
          headerName: "Total Call Today",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
      },
      {
          field: "PendingForAllocation ",
          headerName: "PendingForAllocation",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
      },
      {
          field: "PartPending",
          headerName: "Part Pending",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
      },
    
  ];
  setColumns1(gridCols1);
  setRows1(response1);
  setCount(response1.length);
}, [response1]
);


useEffect(() => {
  const gridCols2 = [
      {
          field: "id",
          headerName: ".",
          renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
          //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ), 
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 70,
      },
      {
          field: "SpareName",
          headerName: "Service Centre",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 170,
      },
      {
          field: "Quantity",
          headerName: "Quantity",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
      },
        
  ];
  setColumns2(gridCols2);
  setRows2(response2);
  setCount(response2.length);
}, [response2]
);

  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, value]);

  const handleChange = (e) => {
    // setCursor(e.target.selectionStart);
    onChange && onChange(e);
  };

  const onSubmit = (values) => {
    debugger;
    setMode("Insert");
   
    var UpdatedByID = sessionStorage.UID;
    var bodyFormData = new FormData();
    bodyFormData.append("LeadID", props.LeadID);
    //bodyFormData.append("POCID",props.POCID);
    bodyFormData.append("POCNo", POCNo);
    bodyFormData.append("POCDate", values.POCDate);
    bodyFormData.append("ProductTypeID", values.ProductTypeID);
    bodyFormData.append("ProductID", values.ProductID);
    bodyFormData.append("CurrentSolution", values.CurrentSolution);
    bodyFormData.append("NoOfUsers", values.NoOfUsers);
    bodyFormData.append("NoOfUsersInPOC", values.NoOfUsersInPOC);
    bodyFormData.append("AD_LDAPSync", values.AD_LDAPSync);
    bodyFormData.append("POCType", values.POCType);
    bodyFormData.append("OnPrimCloud", values.OnPrimCloud);
    bodyFormData.append("Description", values.Description);
    bodyFormData.append("RenewDate", values.RenewDate);
    bodyFormData.append("POCStartDate", values.POCStartDate);
    bodyFormData.append("POCEndDate", values.POCEndDate);
    bodyFormData.append("Description", values.Description);
    //bodyFormData.append("RequestedByID", values.RequestedByID);
    bodyFormData.append("RequestedByID", sessionStorage.UID);
    bodyFormData.append("RequestedOn", values.RequestedOn);
    bodyFormData.append("ApprovedByID", values.ApprovedByID);
    bodyFormData.append("ApprovedOn", values.ApprovedOn);
    bodyFormData.append("UpdatedByID", UpdatedByID);
    // bodyFormData.append("NextFollowupDate", Moment(NextFollowupDate).format('YYYY-MM-DD'));
    bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
 
       fetchData("Lead/SavePOC", bodyFormData);
  };

  const GetComboData = () => {
    debugger;
    fetchComboData("Lead/ComboData");
  };

//   const PopulateData = () => {
//     var bodyFormData = new FormData();
//     debugger;
//     bodyFormData.append("LeadID", props.LeadID);
//     bodyFormData.append("Date", Date); 
//     bodyFormData.append("FollowupBy", FollowupBy);
//     bodyFormData.append("SpokenTo", SpokenTo);
//     bodyFormData.append("Description", Description);
//     bodyFormData.append("Status",Status);
//     bodyFormData.append("NextFollowup",NextFollowup);
      
//     fetchFollowupData("Lead/ListFollowup", bodyFormData);
// }


  // const onFromClear = () => {
  //   setNextFollowupDate();
  //   setdefaultNextFollowupDate();
  // }
 
  const handleRequestPOCOpenModal = (params) => {
    // setMode("Insert");
    // setPOCID(POCID);
    // setRequestPOCOpen(true);
   // setLeadID(LeadID);
    //setRequestPOCID(RequestPOCID);
  };

  const onToClear = () => {
    setToDate();
    setdefaultToDate();
  }
  const POCData = () => {
    debugger;  
    var bodyFormData = new FormData();
    bodyFormData.append("LeadID", props.LeadID);
   // bodyFormData.append("POCID", POCID);
    bodyFormData.append("ContactID", props.ContactID);
    fetchDataGetData("Lead/GetByPOCID", bodyFormData);
    // props.PopulateData();
  };
  useEffect(() => {
    debugger;
     GetComboData();
    if (props.LeadID !== "" ) {
      POCData();
    }
    console.log("LeadID",props.LeadID)
  }, []);

//   const PopulateData = () => {
//     var bodyFormData = new FormData();
//     bodyFormData.append("LeadID", props.LeadID);
//     fetchData("Lead/RequestPOCList", bodyFormData);
// }
 
  const ADLDAPSyncOPtion=[
    { key: "Yes", value: "Yes" },
    { key: "No", value: "No" },
   
  ];
  const ADLDAPSyncData = () => {
    let ADLDAPSynccmb = ADLDAPSyncOPtion.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return ADLDAPSynccmb ;
  };
  let ADLDAPSynccmb  = ADLDAPSyncData();

  const POCTypeOption=[
    { key: "Hybrid", value: "Hybrid" },
    { key: "Stand alone", value: "Stand alone" },
  ]
  const POCTypeData = () => {
    let POCTypecmb = POCTypeOption.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return POCTypecmb ;
  };
  let POCTypecmb = POCTypeData();

  const OnprimOption=[
    { key: "On prim", value: "On prim" },
    { key: "Cloud", value: "Cloud" },
  ]
  const OnprimData = () => {
    let Onprimcmb = OnprimOption.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return Onprimcmb ;
  };
  let Onprimcmb = OnprimData();

  const GetByIDData = () => {
    var bodyFormData = new FormData();
    //bodyFormData.append("LeadID", props.LeadID);
    //bodyFormData.append("POCNo", POCNo);
    bodyFormData.append("POCID", POCID);
    fetchDataGetData("Lead/GetByPOCDataID", bodyFormData);
  };
  useEffect(() => {
    debugger;
   // GetComboData();
   // GetByIDData(props.POCID);
    if (POCID !== "" ) {
      GetByIDData();
    }
    console.log("POCID",POCID)
  }, []);

  const onCheckChange = (e) => {
    debugger;
    setIsChecked(e.target.checked);
    console.log(isChecked);
  };

  useEffect(() => {
    if (props.LeadID !== '') {
      setMode('Update');
  }
  else {
      setMode('Insert');
  }
    if (responseGetData !== undefined && responseGetData.length > 0 && Mode === "Update") {
    debugger;
     //setPOCID(responseGetData[0].POCID);
     setPOCNo(responseGetData[0].POCNo); 
     setPOCDate(responseGetData[0].POCDate);
     setProductTypeID(responseGetData[0].ProductTypeID); 
     setProductID(responseGetData[0].ProductID);    
     setProductCode(responseGetData[0].ProductCode);     
     setProductName(responseGetData[0].ProductName);
     setProductType(responseGetData[0].ProductType);
     setCurrentSolution(responseGetData[0].CurrentSolution);
     setPOCType( responseGetData[0].POCType);
     setNoOfUsers( responseGetData[0].NoOfUsers);
     setNoOfUsersInPOC( responseGetData[0].NoOfUsersInPOC);
     setOnPrimCloud( responseGetData[0].OnPrimCloud);
     setAD_LDAPSync(responseGetData[0].AD_LDAPSync);
     setDescription(responseGetData[0].Description);
     setRequestedByID(responseGetData[0].RequestedByID);
     setRenewDate(responseGetData[0].RenewDate);
     setPOCStartDate(responseGetData[0].POCStartDate);
     setPOCEndDate(responseGetData[0].POCEndDate);
     setRequestedOn(responseGetData[0].RequestedOn);
     //setLeadContactID(responseGetData[0].LeadContactID === null ? "" : responseGetData[0].LeadContactID);    
   }
 }, [responseGetData]);


  // useEffect(() => {
  //   PopulateData();
  // }, [])

  useEffect(() => {
    debugger;
    if (response.Response === true) {
      alert("Data Saved Succesfully.");
      //props.setRequestPOCOpen(false);
      props.setOpen(false);
      props.PopulateData();
    }
    else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
      } else {
        alert("Failed.");
      }
    }
  }, [response]);

  
  return (
    <div>
      <Formik
        initialValues={{          
         POCID:POCID, POCNo: POCNo,POCDate: POCDate, POCType: POCType, ProductTypeID: ProductTypeID,ProductType: ProductType, ProductID: ProductID, ProductCodeID: ProductCodeID, ProductName: ProductName,ProductCode: ProductCode, CurrentSolution: CurrentSolution,
          NoOfUsers:NoOfUsers, AD_LDAPSync: AD_LDAPSync, POCType: POCType, OnPrimCloud: OnPrimCloud, NoOfUsersInPOC:NoOfUsersInPOC, Description:Description,RenewDate:RenewDate,
          POCStartDate:POCStartDate,POCEndDate:POCEndDate,RequestedByID:RequestedByID,RequestedOn:RequestedOn
        }}
        //validationSchema={validationSchema}
        onSubmit={onSubmit} 
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              {/* <Typography
                className={classes.headertext}
                style={{ marginTop: "-16px" }}
                noWrap
              >
                Lead Information
              </Typography> */}
              
              <Grid spacing={1} container direction="row">
              <Grid item xs={2} >
                  <label
                    htmlFor={"ModelCode"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Model Code"}
                  </label>
                </Grid>
                <Grid item xs={5} >
                  <BiztranControlsFormik
                    control="input"
                    name="ModelCode"
                    ref={ref}
                    value={POCNo}
                    disabled={true}                   
                    onChange={(e) => setPOCNo(e.target.value)}
                  />
                </Grid>
                </Grid>
                <Grid spacing={1} container direction="row">
                <Grid item xs={2} >
                  <label
                    htmlFor={"ModelName"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Model Name"}
                  </label>
                </Grid>
                <Grid item xs={10}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="ModelName"
                    id="ProductType"
                    //disabled={true}
                    ref={ref}
                    value={ProductType}                  
                    onChange={(e) => {
                      setProductType(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"ModelType"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Model Type"}
                  </label>
                </Grid>
                <Grid item xs={10} >
                  <BiztranControlsFormik
                    autoFocus="autofocus"
                    control="select"
                    type="text"
                    name="ModelType"
                    ref={ref}
                    value={ProductCode}
                   // disabled={true}
                    onChange={(e) => {
                      setProductCode(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"ModelCategory"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Model Category"}
                  </label>
                </Grid>
                <Grid item xs={10} >
                  <BiztranControlsFormik
                    autoFocus="autofocus"
                    control="select"
                    type="text"
                    name="ModelCategory"
                    ref={ref}
                    value={ProductName}
                    // disabled={true}
                    onChange={(e) => {
                      setProductName(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"ProductGroup"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Product Group"}
                  </label>
                </Grid>
                <Grid item xs={10} >
                  <BiztranControlsFormik
                    autoFocus="autofocus"
                    control="select"
                    type="text"
                    name="ProductGroup"
                    ref={ref}
                    value={CurrentSolution}                   
                    onChange={(e) => {
                      setCurrentSolution(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Specification"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Specification"}
                  </label>
                </Grid>
                <Grid item xs={10} >
                  <BiztranControlsFormik
                    autoFocus="autofocus"
                    control="textarea"
                    type="text"
                    name="Specification"
                    ref={ref}
                    value={CurrentSolution}                   
                    onChange={(e) => {
                      setCurrentSolution(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"WarrantyPeriod"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Warranty Period(in month)"}
                  </label>
                </Grid>
                <Grid item xs={10} >
                  <BiztranControlsFormik
                    autoFocus="autofocus"
                    control="input"
                    type="text"
                    name="WarrantyPeriod"
                    ref={ref}
                    value={CurrentSolution}                   
                    onChange={(e) => {
                      setCurrentSolution(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"WarrantyTerms"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Warranty Terms"}
                  </label>
                </Grid>
                <Grid item xs={10} >
                  <BiztranControlsFormik
                    autoFocus="autofocus"
                    control="input"
                    type="text"
                    name="WarrantyTerms"
                    ref={ref}
                    value={ProductName}
                    // disabled={true}
                    onChange={(e) => {
                      setProductName(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"ServiceCharge"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Service Charge"}
                  </label>
                </Grid>
                <Grid item xs={10} >
                  <BiztranControlsFormik
                    autoFocus="autofocus"
                    control="input"
                    type="text"
                    name="ServiceCharge"
                    ref={ref}
                    value={ProductName}
                    // disabled={true}
                    onChange={(e) => {
                      setProductName(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2} >
                  <label
                    htmlFor={"ProductImage"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Product Image"}
                  </label>
                </Grid>
                <Grid item xs={3} >
                       <BiztranControls.Button
                        text="Choose File"
                        type="submit"
                        startIcon={<SaveIcon />}
                        style={{ width: "70%" }}
                      />
                     
                </Grid>
              
           </Grid>
                <Grid item xs={12}>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                    >
                        
                      <BiztranControls.Button
                        text="Update"
                        type="submit"
                        startIcon={<SaveIcon />}
                        style={{ width: "18%" }}
                      />
                     
                      <BiztranControls.Button
                        text="Search"
                        startIcon={<CloseIcon />}
                        onClick={() => {
                          props.setOpen(false);
                        }}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} spacing={1} container direction="row">
                <Grid item xs={8}  >
                  <BiztranControlsFormik
                    autoFocus="autofocus"
                   // control="input"
                    control="textarea"
                    type="text"
                    name="PINCode"
                    ref={ref}
                    value={Description}                 
                    onChange={(e) => {
                      setDescription(e.target.value)
                      handleChange()
                    }}
                  />
                  </Grid>
                       <Grid item xs={4} >
                       <BiztranControls.Button
                        text="Add Multiple Spares"
                        type="submit"
                        startIcon={<SaveIcon />}
                        style={{ width: "70%" }}
                      />
                     
                </Grid>
                </Grid>
                <Grid item spacing={2} xs={12} container direction='row'>
                <Grid item xs={8} >
                    <label
                        htmlFor={"ProductAttachment"}
                        style={{
                            display: "block",
                            width: "100%",
                            fontSize: 20,
                            fontWeight: "bold",
                        }}
                    >
                        {"Product Attachment"}
                    </label>
                </Grid>
                
                       <Grid item xs={4} >
                       <BiztranControls.Button
                        text="Add "
                        type="submit"
                        startIcon={<SaveIcon />}
                        style={{ width: "25%" }}
                      />
                     
                </Grid>
            </Grid>
            <Grid spacing={1}item xs={12} container direction="row">
              <Grid item xs={2} >
                  <label
                    htmlFor={"SrNo"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"SrNo"}
                  </label>
                </Grid>
                <Grid item xs={2} >
                  <BiztranControlsFormik
                    control="input"
                    name="SrNo"
                    ref={ref}
                    value={POCNo}                   
                    onChange={(e) => setPOCNo(e.target.value)}
                  />
                </Grid>
                <Grid item xs={2} >
                  <label
                    htmlFor={"AttachmentType"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Attachment Type"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="AttachmentType"
                    id="ProductType"
                    //disabled={true}
                    ref={ref}
                    value={ProductType}                  
                    onChange={(e) => {
                      setProductType(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={3} >
                       <BiztranControls.Button
                        text="Choose File"
                        type="submit"
                        startIcon={<SaveIcon />}
                        style={{ width: "70%" }}
                      />
                     
                </Grid>
                </Grid>
           
{/*                
              <BiztranControls.DataGrid
            rowHeight={25}
            headerHeight={34}
            rows={rows}
            columns={columns}
            checkboxSelection={false}
            autoHeight={true}
            hideFooter={true}
            // Height="200px"
            Width="100%"
           />          */}
               {/* </Grid>    */}
               
               {/* <Grid spacing={2} container direction="row">
              <Grid item xs={10} style={{marginTop:2}}>
              <a href="javascript:;" onClick={() => {handleRequestPOCOpenModal (); }} > Opening Stock</a></Grid>
               <BiztranControls.DataGrid
            rowHeight={25}
            headerHeight={34}
            rows={rows1}
            columns={columns1}
            checkboxSelection={false}
            autoHeight={true}
            hideFooter={true}
            Width="100%"
        />  
        </Grid>    */}
           
        {/* <Grid spacing={2} container direction="row">
              <Grid item xs={10} style={{marginTop:2}}>
              <a href="javascript:;" onClick={() => {handleRequestPOCOpenModal (); }} > MSL</a></Grid>
               <BiztranControls.DataGrid
            rowHeight={25}
            headerHeight={34}
            rows={rows2}
            columns={columns2}
            checkboxSelection={false}
            autoHeight={true}
            hideFooter={true}
            Width="100%"
        />  
        </Grid>    */}
        {/* <Grid spacing={2} container direction="row">
              <Grid item xs={10} style={{marginTop:2}}>
              <a href="javascript:;" onClick={() => {handleRequestPOCOpenModal (); }} > Call Charge Parameter</a></Grid>
       </Grid> */}
       {/* <Grid item xs={12}>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                    >
                        
                      <BiztranControls.Button
                        text="Save"
                        type="submit"
                        startIcon={<SaveIcon />}
                        style={{ width: "18%" }}
                      />
                    
                    </div>
                  </div>
                </Grid> */}

            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    paddingLeft: "30px",
    fontSize: "1.5rem",
    //marginTop: "-16px",
    marginBottom: "10px",
    marginLeft: "-24px",
    marginRight: "-24px",
    //borderRadius: "1rem",
  },
}));

 export default ProductMaster;